import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JPCJPY from '../../assets/flagsCFD/JPCJPY.svg';
import DJCUSD from '../../assets/flagsCFD/DJCUSD.svg';
import NACUSD from '../../assets/flagsCFD/NACUSD.svg';
import SPCUSD from '../../assets/flagsCFD/SPCUSD.svg';
import RTCUSD from '../../assets/flagsCFD/RTCUSD.svg';
import GECEUR from '../../assets/flagsCFD/GECEUR.svg';
import UKCGBP from '../../assets/flagsCFD/UKCGBP.svg';
import HKCHKD from '../../assets/flagsCFD/HKCHKD.svg';

import styles from './customFlagCFD.module.scss';

const CFD_FLAG_TYPE = {
  JPCJPY,
  DJCUSD,
  NACUSD,
  SPCUSD,
  RTCUSD,
  GECEUR,
  UKCGBP,
  HKCHKD,
  JPC_MJPY: JPCJPY,
  DJC_MUSD: DJCUSD,
  NAC_MUSD: NACUSD,
  SPC_MUSD: SPCUSD,
  RTC_MUSD: RTCUSD,
  GEC_MEUR: GECEUR,
  UKC_MGBP: UKCGBP,
  HKC_MHKD: HKCHKD,
  JPC_APJPY: JPCJPY,
  DJC_APUSD: DJCUSD,
  NAC_APUSD: NACUSD,
  SPC_APUSD: SPCUSD,
  RTC_APUSD: RTCUSD,
  GEC_APEUR: GECEUR,
  UKC_APGBP: UKCGBP,
  HKC_APHKD: HKCHKD,
};

const CustomFlagCFD = ({ flagType, className, size }) => {
  const currencyFlagType = flagType.replace('/', '').split('.')[0];
  const src = useMemo(() => CFD_FLAG_TYPE[currencyFlagType], [currencyFlagType]);
  if (!src) return null;
  const sizeStyle = size ? { width: size, height: size } : undefined;
  return (
    <img src={src} style={sizeStyle} className={classNames(styles.flagImage, { [className]: className })} alt="" />
  );
};

CustomFlagCFD.propTypes = {
  flagType: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

CustomFlagCFD.defaultProps = {
  className: '',
  size: undefined,
};

export default memo(CustomFlagCFD);
